export function normalizeAmountToMinor(amount: number | null | undefined): number {
    if (amount == null) return 0
    if (typeof amount === "number") {
        if (Number.isInteger(amount)) return amount * 100
        return Math.round(amount * 100)
    }
    const numeric = Number(amount)
    if (!Number.isFinite(numeric)) return 0
    return Math.round(numeric * 100)
}

export function formatCurrencyDisplay(amountMinor: number, currency: string): string {
    try {
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency,
        }).format(amountMinor / 100)
    } catch {
        const normalizedCurrency = (currency ?? "").toUpperCase() || "USD"
        return `${normalizedCurrency} ${(amountMinor / 100).toFixed(2)}`
    }
}
